module.exports = true;



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/core-js/library/modules/_library.js
 ** module id = 331
 ** module chunks = 0
 **/